module.exports = __webpack_public_path__ + "static/media/organization_companyname.adedb37b.svg";